import React from 'react';

import cn from 'classnames';
import { number, bool, func, string, shape } from 'prop-types';

import Radio from '@mui/material/Radio';

import ClickableComponent from 'components/Common/ClickableComponent';

import s from './SwitcherDropdown.css';

const SwitcherDropdown = ({
  setAnchor,
  isMobile,
  options,
  setOption,
  selectedOption,
}) => (
  <div className={cn(s.dropdown, { [s.mobile]: isMobile })}>
    <div className={s.infoText}>
      Switch your currently active mode on SchooLinks:
    </div>

    {Object.keys(options).map(dashboard => {
      const item = options[dashboard];
      const { icon, title } = item;

      return (
        <ClickableComponent
          key={dashboard}
          className={s.optionItem}
          onClick={() => {
            setOption(dashboard);
            setAnchor(null);
          }}
        >
          <Radio
            className={s.radio}
            tabIndex={-1}
            checked={dashboard === selectedOption}
          />
          <div className={s.greyIcon}>{icon}</div>
          <div className={s.optionName}>{title}</div>
        </ClickableComponent>
      );
    })}
  </div>
);

export const OptionPropTypes = {
  id: number.isRequired,
  title: string.isRequired,
  icon: shape({}).isRequired,
};

SwitcherDropdown.propTypes = {
  setAnchor: func.isRequired,
  isMobile: bool.isRequired,
  options: shape({}).isRequired,
  selectedOption: string.isRequired,
  setOption: func.isRequired,
};

export default SwitcherDropdown;
